import { createSlice } from "@reduxjs/toolkit";

const CompanySlice = createSlice({
	name: "Company",
	initialState: {
		company_name: "",
		address: "",
		motto: "",
		c_url: "",
		auth_token: "",
		m_id: "",
		t_id: "",
		available_table: [],
		selected_table: "",
		BranchId: "",
		storeId: "",
		SalesPoint: "",
		SalesPointName: "",
		paystack_pk: "",
		paystackEnabled: "",
		bg_image: false,
		shippingsList: [],
		company_settings: [],
		shippingsEnabled: [],
		//CODE added by Jeremiah
		//GET COMPANY ADDRESS, CITY, MOBILE, STATE AND COUNTRY
		companyAddress: "",
		comapanyCity: "",
		companyState: "",
		companyCountry: "",
		companyMobile: "",
		selected_tableId: "",
		table_menu_id: "",
		tableNo: "",
		tableId: "",
		waiterCall: [],
		POSLic: "",
		reviewLic:"",
		//End code
	},
	reducers: {
		setCompanyName: (state, action) => {
			state.company_name = action.payload;
		},
		setBgImage: (state, action) => {
			state.bg_image = action.payload;
		},
		setAddress: (state, action) => {
			state.address = action.payload;
		},
		setMotto: (state, action) => {
			state.motto = action.payload;
		},
		setC_URL: (state, action) => {
			state.c_url = action.payload;
		},
		setAuthToken: (state, action) => {
			state.auth_token = action.payload;
		},
		setM_ID: (state, action) => {
			state.m_id = action.payload;
		},
		setT_ID: (state, action) => {
			state.t_id = action.payload;
		},
		setAV_TB: (state, action) => {
			state.available_table = action.payload;
		},
		setSL_TB: (state, action) => {
			state.selected_table = action.payload;
		},
		setBranchId: (state, action) => {
			state.BranchId = action.payload;
		},
		setStoreId: (state, action) => {
			state.storeId = action.payload;
		},
		setSalesPoint: (state, action) => {
			state.SalesPoint = action.payload;
		},
		setSalesPointName: (state, action) => {
			state.SalesPointName = action.payload;
		},
		setPaystack: (state, action) => {
			state.paystack_pk = action.payload;
		},
		setPaystackEnabled: (state, action) => {
			state.paystackEnabled = action.payload;
		},
		//CODE added by Jeremiah
		//SET COMPANY MOBILE, ADDRESS, CITY, STATE AND COUNTRY
		setCompanyAddress: (state, action) => {
			state.companyAddress = action.payload;
		},
		setCompanyCity: (state, action) => {
			state.companyCity = action.payload;
		},
		setCompanyState: (state, action) => {
			state.companyState = action.payload;
		},
		setCompanyMobile: (state, action) => {
			state.companyMobile = action.payload;
		},
		setCompanyCountry: (state, action) => {
			state.companyCountry = action.payload;
		},
		setShippingsList: (state, action) => {
			state.shippingsList = action.payload;
		},
		setShippingsEnabled: (state, action) => {
			state.shippingsEnabled = action.payload;
		},
		setCompanySettings: (state, action) => {
			state.company_settings = action.payload;
		},
		setSL_TB_ID: (state, action) => {
			state.selected_tableId = action.payload;
		},
		setTableMenuId: (state, action) => {
			state.table_menu_id = action.payload;
		},
		setTableNo: (state, action) => {
			state.tableNo = action.payload;
		},
		setTableID: (state, action) => {
			state.tableId = action.payload;
		},
		setWaiterCall: (state, action) => {
			state.waiterCall = action.payload;
		},
		setPOSLic: (state, action) => {
			state.POSLic = action.payload;
		},
		setReviewLic: (state, action) => {
			state.reviewLic = action.payload;
		},
		// setTableNumber(state, action) =>{
		// 	state.table+ = action.payload;
		// }
		//END CODE
	},
});

export const CompanyActions = CompanySlice.actions;

export default CompanySlice;
